import { useParams } from "react-router-dom";

import { useLocalization, translateOperationalModule } from "@i18n";

interface OperationalModuleStructurePageProps {
  /** Valor canônico `module` do catálogo (ex.: "General"). */
  moduleKey: string;
}

// Contexto de estrutura /<slug>/:structureId (fatia 3): o loader operacional já
// garantiu publicação, autorização e estrutura acessível antes de montar esta
// árvore. O CONTEÚDO de negócio de cada módulo chega na fatia do respectivo
// módulo (ex.: Geral na fatia 4 — quality-test §0.3.2 / §0.5); aqui fica o
// placeholder que ancora as telas internas (/<slug>/:structureId/...).
export const OperationalModuleStructurePage = ({
  moduleKey,
}: OperationalModuleStructurePageProps) => {
  const { translate } = useLocalization();
  const { structureId } = useParams();

  return (
    <section className="flex flex-col gap-2 p-6" data-structure-id={structureId}>
      <h1 className="text-2xl font-semibold">
        {translateOperationalModule(moduleKey, translate)}
      </h1>
      <p className="text-sm text-muted-foreground">
        {translate("operationalModules.placeholder.underConstruction")}
      </p>
    </section>
  );
};
